import React, { useContext, useState, useRef, useEffect } from "react";
import { IoArrowBack, IoArrowForward, IoPlay, IoPause } from "react-icons/io5";
import { useSelector, useDispatch } from "react-redux";
import { ThemeContext } from "../../pages/qcast-logo";

import { CircularProgressbar } from "react-circular-progressbar";
import { ControlBar, Player } from "video-react";

const Play = (props) => {
  const theme = useContext(ThemeContext);
  const { bg, font } = theme;

  const currentQcast = useSelector((state) => state.qcast.currentQcast);

  const [currentVidIndex, setCurrentVidIndex] = useState(0);
  const [vidInfo, setVidInfo] = useState({});

  const vidRef = useRef(null);

  useEffect(() => {
    // subscribe state change
    vidRef.current.subscribeToStateChange(handleVidStateChange);
  }, []);

  const handleVidStateChange = (state) => {
    // copy player state to this component's state
    setVidInfo(state);
  };

  const handleControl = () => {
    if (vidInfo.paused || vidInfo.ended) {
      vidRef.current.play();
    } else {
      vidRef.current.pause();
    }
  };

  return (
    <div className="w-[19rem] md:w-[24rem] lg:w-[29rem] flex flex-col overflow-hidden">
      <nav className="w-full flex flex-row justify-center space-x-2 px-2 items-center py-2 ">
        <button
          className="w-[1.2rem] h-[1.5rem] lg:w-[1.5rem] aspect-square rounded-full bg-[#8DACCD54] border border-[#D1E6FC] flex flex-col "
          onClick={props.back}
        >
          <IoArrowBack className="m-auto w-full text-xs lg:text-sm fill-[#2C3037]" />
        </button>
        <p
          style={{ backgroundColor: bg, color: font }}
          className="mr-5 backdrop-blur-[50px] px-6 rounded-full w-fit  text-xs font-semibold py-2 justify-self-center"
        >
          Play Qcast
        </p>
        <span></span>
      </nav>
      {/* BODY */}
      <div className="w-full px-2 md:px-8 lg:px-[4rem] flex flex-col space-y-1 items-center pb-6">
        <span className="relative w-[270px] h-[270px] rounded-full overflow-hidden flex flex-col">
          <CircularProgressbar
            value={vidInfo.currentTime || 0}
            maxValue={vidInfo.duration || 60}
            strokeWidth={4}
            styles={{
              trail: {
                stroke: `#FFF`,
              },
              path: {
                transition: "0ms",
              },
            }}
          />
          <div
            id="respond-video-record"
            className="relative w-[250px] rounded-full overflow-hidden aspect-square m-auto mt-[.6rem] flex flex-col"
          >
            <Player
              ref={vidRef}
              src={currentQcast.listOfVideos[currentVidIndex]}
              className="rounded-full overflow-hidden bg-black"
              width={250}
              height={250}
              fluid={false}
            >
              <ControlBar disableCompletely></ControlBar>
            </Player>

            <button
              onClick={handleControl}
              className="absolute bottom-3 left-[50%] transform -translate-x-1/2"
            >
              {!vidInfo.paused ? (
                <IoPause className="text-2xl text-white" />
              ) : (
                <IoPlay className="text-2xl text-white" />
              )}
            </button>
          </div>
        </span>

        <div className="text-center bg-[#FFFFFFCC] shadow-md rounded-[20px] p-4">
          <p className="text-[#2C3037] text-sm mb-2">{currentQcast.title}</p>
          <div className="w-full flex flex-row items-center justify-between text-xl space-x-5">
            <span className="flex flex-row items-center space-x-1">
              <button
                className={`bg-gradient-to-b from-[#F1F9FF] to-[#DCE8F6] rounded-full p-1 ${
                  currentVidIndex === 0 ? "invisible" : ""
                }`}
                onClick={() => setCurrentVidIndex((prev) => prev - 1)}
              >
                <IoArrowBack
                  color={bg}
                  className="text-[#7B94B5] text-sm lg:w-[1.5rem] lg:h-[1.5rem]"
                />
              </button>
              <p className="text-sm">
                {currentVidIndex + 1} of {currentQcast.numberOfVideo}
              </p>
              <button
                className={`bg-gradient-to-b from-[#F1F9FF] to-[#DCE8F6] rounded-full p-1 ${
                  currentVidIndex + 1 === currentQcast.numberOfVideo
                    ? "invisible"
                    : ""
                }`}
                onClick={() => setCurrentVidIndex((prev) => prev + 1)}
              >
                <IoArrowForward
                  color={bg}
                  className="text-[#7B94B5] text-sm lg:w-[1.5rem] lg:h-[1.5rem]"
                />
              </button>
            </span>
            <button
              onClick={props.respond}
              style={{ backgroundColor: bg, color: font }}
              className="text-xs lg:text-sm px-5 p-1 rounded-full shadow-md text-white"
            >
              Respond
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Play;
